import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaDebeFormGroup = ({ value, nameValue, onChange, clickClear }) => {
  return (
    <Form.Group>
      <Form.Label text='C. DEBE' htmlFor='input-cuentaDebe' md={4} />
      <Col md={8}>
        {nameValue ? (
          <ClearInputGroup iValue={nameValue} id='readonly-cuentaDebe' clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select2-cuentaDebe' onChange={onChange} onlyAnalitica />
        )}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaDebeFormGroup)
